import * as types from './mutations_types.js'

export default {
  SET_SONG: ({commit}, song) => {
    commit(types.SET_SONG, song)
  },
  SET_POPULAR: ({commit}, popular) => {
    commit(types.SET_POPULAR, popular)
  }
}



// WEBPACK FOOTER //
// ./src/store/song/actions.js